import React, { useContext, useEffect, useState } from "react";
import { Table, Space, message } from "antd"; // Import Ant Design table
import { AiOutlineMail, AiOutlineRise } from "react-icons/ai"; // Import mail icon
import { getAllQueries } from "../../webServices/Apis";
import Loader from "../Loader/Loader";
import moment from "moment";
import { each } from "chart.js/helpers";
// import 'antd/dist/antd.css'; // Import Ant Design styles

import { useNavigate } from "react-router";
import { UserContext } from "../../App";

function Query() {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch the user queries (this would be replaced by your actual API call)
  const fetchQueries = async () => {
    try {
      const id = Number(localStorage.getItem("userId"))
      const response = await getAllQueries();
      
      // const filterdata = response?.data?.data?.filter((each)=> each.adminId === id)
  

      // const queryMaps = filterdata.map((each) => ({
      //   ...each,
      //   createdAt: moment(each.createdAt).format("MMM Do YY"),
      // }));
      const reverseQueries = [...response?.data?.data].reverse()
      setQueries(reverseQueries);

    } catch (error) {
      if (error?.response?.status === 500) {
        message.error("Server not responding")
      }

      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      }
      console.error("Error fetching queries:", error);
    } finally {
      setLoading(false);
    }
  };

  // Load data when the component mounts  
  useEffect(() => {

    fetchQueries();
  }, []);

  // Define the columns for the Ant Design table
  const columns = [
    {
      title: "Query Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Query",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* Mailto link for sending an email */}
          <a
            href={`mailto:${record.email}`}
            title={`Send email to ${record.name}`}
          >
            <AiOutlineMail size={24} color="blue" />
          </a>
        </Space>
      ),
    },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {loading && <Loader />}
      <h1 className="text-3xl font-semibold mb-6 text-gray-800">
        User Queries
      </h1>

      <div className="bg-white shadow-md rounded-lg p-6">
        {/* Ant Design Table for displaying the user queries */}
        <Table
          columns={columns}
          dataSource={queries}
          pagination={{ pageSize: 9 }}
        />
      </div>
    </div>
  );
}

export default Query;
